export enum ResponseMessageType {
    SUCCESS = 'Success',
    ERROR = 'Error',
    DUPLICATENAME = 'Duplicate connection',
    CONN_ALREADY_EXISTS = 'Connection name already exist'
}
